var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{class:_vm.model.class || _vm.config.class,attrs:{"outlined":"","value":_vm.value,"label":_vm.model.title,"error-messages":_vm.error,"disabled":_vm.disabled,"hide-details":_vm.config.hideDetails || false,"dense":_vm.config.dense || false},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }